// import Vue from "vue";
// import VueRouter from "vue-router";
import Index from "../views/index.vue";
import agreement from './modules/agreement';
import fundDetail from './modules/fundDetail'
import privatePage from './modules/privatePage'
import personalPage from './modules/personalCenter'
import store from '../store'
import accountPage from "./modules/openAccount";
import organAccountPage from "./modules/orgAccount";
import additionalRecordingPage from "./modules/additionalRecording";
import liveStreaming from "./modules/live";
import publicFundsChange from "./modules/publicFundsChange"
import assetsPage from "./modules/assets"
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "",
    component: Index,
    redirect: "/transitPage",
    children: [
      {
        path:"/index",
        name:'homeIndex',
        component:() => import("../views/Index/index.vue"),
        meta: {
          title: "",
          singleHead: true,
        },
      },
      {
        path: "/transitPage",
        name: "开始测评",
        component: () => import("../views/other/transitPage.vue"),
        meta: {
          title: "风险测评",
        },
      },
      {
        path: "/problem",
        name: "测评答题",
        component: () => import("../views/riskAssessment/problem.vue"),
        meta: {
          title: "风险测评",
        },
      },
      {
        path: "/results",
        name: "风险测评结果确认",
        component: () => import("../views/riskAssessment/results.vue"),
        meta: {
          title: "风险测评结果确认",
        },
      },
      {
        path: "/questionnaireResults",
        name: "questionnaireResults",
        component: () => import("../views/riskAssessment/questionnaireResults.vue"),
        meta: {
          title: "问卷结果",
        },
      },
      {
        path: "/explain",
        name: "匹配说明",
        component: () => import("../views/riskAssessment/explain.vue"),
        meta: {
          title: "匹配说明",
        },
      },
      // 协议路由
      ...agreement,
      // 基金详情路由
      ...fundDetail,
      // 一级私募详情页面
      ...privatePage,
      //  机构开户
      ...accountPage,
      // 个人中心
      ...personalPage,
      ...organAccountPage,
      ...additionalRecordingPage,
      ...liveStreaming,
      // 公募基金改版
      ...publicFundsChange,
      //其他路由
      {
        path: '/callback',
        name: "签约招行",
        meta: {
          title: "",
          singleHead: true
        },
        component: () => import('../views/other/pinganCallBack.vue') // 假设回调页面组件是 Callback.vue
      },
      //资产改版
      ...assetsPage,
      {
        path: "/publicFundsDealRules",
        name: "交易规则",
        component: () => import("../views/publicFunds/dealRules.vue"),
        meta: {
          title: "交易规则",
        },
      },
      {
        path: "/publicFundsManager",
        name: "基金经理",
        component: () => import("../views/publicFunds/fundManagerList.vue"),
        meta: {
          title: "基金经理",
        },
      },
      {
        path: "/publicFundsManagerDetail",
        name: "基金经理",
        component: () => import("../views/publicFunds/fundManagerDetail.vue"),
        meta: {
          title: "基金经理",
        },
      },
      {
        path: "/bannerLink",
        name: "了解陆享基金",
        component: () => import("../views/Index/bannerLink.vue"),
        meta: {
          title: "",
          singleHead: true
        },
      },
    ],

  },
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
//push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  // const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    // router.replace(targetPath);
    location.reload()
  }
});
router.afterEach(to => {
  
  let {
    meta = {}
  } = to || {};
  let {
    showBg,
    title
  } = meta;
  if (showBg) {
    setTimeout(() => {
      store.dispatch("getBg", true)
    }, 100);
  } else {
    setTimeout(() => {
      store.dispatch("getBg", false)
    }, 100);
  }
});
export default router;